import { pad } from "../services/datetime";

export const parseEventTime = (datetime) => {
  const dateObj = new Date(datetime);
  return `${pad(dateObj.getHours())}:${pad(dateObj.getMinutes())}`;
};
